import React from 'react';
import NotFound from '../components/NotFound.jsx';

export default function CertificateNotFound() {
    return <NotFound />;
}
